// extracted by mini-css-extract-plugin
export default {"wrapper":"empty_wrapper__DT6K3","content":"empty_content__cupx5"};